import React from "react";
import Api2 from "../../services/Api2";
import {
  MDBEdgeHeader,
  MDBFreeBird,
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBCardBody,
  MDBIcon,
  MDBCard,
  MDBCardTitle,
  MDBCardImage,
  MDBCardText,
  MDBAnimation,
  MDBNavLink,
  MDBBtn,
  MDBProgress,
  MDBTypography,
  MDBView,
  MDBSpinner,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import { Pie, Bar, Line } from "react-chartjs-2";
import "./HomePage.css";
import TopNavbar from "../../components/topNavbar";
class HomePage extends React.Component {
  state = [];
  scrollToTop = () => window.scrollTo(0, 0);
  componentDidMount = async () => {
    await Api2.get("count")
      .then((d) =>
        this.setState({
          data: d.data,
          loading: false,
        })
      )
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    if (this.state.data) {
      console.log(parseInt(this.state.data.total_bulanan[0].jan));
    }
    const formatRupiah = (nilai) => {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
      }).format(nilai);
    };
    let random1 = "loading..";
    if (this.state.data) {
      random1 = (
        (this.state.data.realisasi / this.state.data.target) *
        100
      ).toFixed(2);
    }
    let random2 = "loading..";
    if (this.state.data) {
      random2 = (
        (this.state.data.realisasi_bulan_ini / (this.state.data.target / 12)) *
        100
      ).toFixed(2);
    }
    let random3 = "loading..";
    if (this.state.data) {
      random3 = (
        (this.state.data.realisasi_bulan_lalu / (this.state.data.target / 12)) *
        100
      ).toFixed(2);
    }
    let random4 = "loading..";
    if (this.state.data) {
      random4 =
        100 -
        ((this.state.data.realisasi / this.state.data.target) * 100).toFixed(2);
    }
    let colorProgress1 =
      random1 > 35 && random1 < 70
        ? "warning"
        : random1 > 70
        ? "success"
        : "danger";
    let colorProgress2 =
      random2 > 35 && random2 < 70
        ? "warning"
        : random2 > 70
        ? "success"
        : "danger";
    let colorProgress3 =
      random3 > 35 && random3 < 70
        ? "warning"
        : random3 > 70
        ? "success"
        : "danger";
    let colorProgress4 =
      random4 < 35 && random4 > 70
        ? "warning"
        : random4 < 70
        ? "success"
        : "danger";

    const dataBarChart = {
      dataBar: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Mei",
          "Jun",
          "Jul",
          "Agu",
          "Sep",
          "Okt",
          "Nov",
          "Des",
        ],
        datasets: [
          {
            label: "Realisasi",
            data: [
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].jan : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].feb : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].mar : 0
              ),
              parseInt(
                this.state.data && this.state.data.total_bulanan[0].apr
                  ? this.state.data.total_bulanan[0].apr
                  : 0
              ),
              parseInt(
                this.state.data && this.state.data.total_bulanan[0].mei
                  ? this.state.data.total_bulanan[0].mei
                  : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].juni : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].juli : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].agu : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].sep : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].okt : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].nov : 0
              ),
              parseInt(
                this.state.data ? this.state.data.total_bulanan[0].des : 0
              ),
            ],
            backgroundColor: [
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
            ],
            borderWidth: 2,
            borderColor: [
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
              "rgba(255, 134, 159, 1)",
            ],
          },
          {
            label: "Target",
            data: [
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
              parseInt(this.state.data && this.state.data.target / 12),
            ],
            backgroundColor: [
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
            ],
            borderWidth: 2,
            borderColor: [
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
              "rgba(104, 109, 224,1.0)",
            ],
          },
        ],
      },
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          xAxes: [
            {
              barPercentage: 1,
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)",
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(255, 177, 101, 1)",
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      dataLine: {
        labels: ["2020", "2021", "2022", "2023", "2024"],
        datasets: [
          {
            label: "Realisasi",
            fill: true,
            lineTension: 0.3,
            backgroundColor: "rgba(235, 77, 75,0.5)",
            borderColor: "rgba(235, 77, 75,1.0)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgb(205, 130,1 58)",
            pointBackgroundColor: "rgb(255, 255, 255)",
            pointBorderWidth: 10,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgb(0, 0, 0)",
            pointHoverBorderColor: "rgba(220, 220, 220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [
              this.state.data && this.state.data.realisasi_tahunan.a2020
                ? this.state.data.realisasi_tahunan.a2020
                : 0,
              this.state.data && this.state.data.realisasi_tahunan.a2021
                ? this.state.data.realisasi_tahunan.a2021
                : 0,
              this.state.data && this.state.data.realisasi_tahunan.a2022
                ? this.state.data.realisasi_tahunan.a2022
                : 0,
              this.state.data && this.state.data.realisasi_tahunan.a2023
                ? this.state.data.realisasi_tahunan.a2023
                : 0,
              this.state.data && this.state.data.realisasi_tahunan.a2024
                ? this.state.data.realisasi_tahunan.a2024
                : 0,
              this.state.data && this.state.data.realisasi_tahunan.a2025
                ? this.state.data.realisasi_tahunan.a2025
                : 0,
            ],
          },
          {
            label: "Target",
            fill: true,
            lineTension: 0.3,
            backgroundColor: "rgba(104, 109, 224,1.0)",
            borderColor: "rgba(104, 109, 224,1.0)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgb(35, 26, 136)",
            pointBackgroundColor: "rgb(255, 255, 255)",
            pointBorderWidth: 10,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgb(0, 0, 0)",
            pointHoverBorderColor: "rgba(220, 220, 220, 1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [
              this.state.data && this.state.data.target_tahunan.a2020
                ? this.state.data.target_tahunan.a2020
                : 0,
              this.state.data && this.state.data.target_tahunan.a2021
                ? this.state.data.target_tahunan.a2021
                : 0,
              this.state.data && this.state.data.target_tahunan.a2022
                ? this.state.data.target_tahunan.a2022
                : 0,
              this.state.data && this.state.data.target_tahunan.a2023
                ? this.state.data.target_tahunan.a2023
                : 0,
              this.state.data && this.state.data.target_tahunan.a2024
                ? this.state.data.target_tahunan.a2024
                : 0,
              this.state.data && this.state.data.target_tahunan.a2025
                ? this.state.data.target_tahunan.a2025
                : 0,
              ,
            ],
          },
        ],
      },

      lineOption: {
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return (
                "Rp " +
                data.datasets[0].data[tooltipItems.index].toLocaleString(
                  "id-ID"
                )
              );
            },
          },
        },

        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return value.toLocaleString("id-ID");
                },
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return value.toLocaleString("id-ID");
                },
              },
            },
          ],
        },
      },
    };
    let tableSkpd = (
      <tr>
        <td>loading..</td>
        <td>loading..</td>
        <td>loading..</td>
        <td>loading..</td>
        <td className="bg-warning">loading..</td>
      </tr>
    );
    if (this.state.data) {
      tableSkpd = this.state.data.skpd_total.map((data, key) => {
        let persen = ((data.realisasi_total / data.target) * 100).toFixed(2);
        let warna =
          persen < 10
            ? "bg-red-500"
            : persen > 10 && persen < 20
            ? "bg-red-300"
            : persen > 20 && persen < 30
            ? "bg-yellow-500"
            : persen > 30 && persen < 50
            ? "bg-yellow-300"
            : persen > 50 && persen < 60
            ? "bg-green-200"
            : persen > 60 && persen < 70
            ? "bg-green-400"
            : persen > 70 && persen < 99
            ? "bg-green-500"
            : persen > 100
            ? "bg-blue-400"
            : "bg-white";
        return (
          <tr key={key} className={warna}>
            <td className="font-bold">{key + 1}</td>
            <td className="font-bold">{data.name}</td>
            <td className="font-bold">{formatRupiah(data.target)}</td>
            <td className="font-bold">{formatRupiah(data.realisasi_total)}</td>
            <td className="font-bold">{persen + "%"}</td>
          </tr>
        );
      });
    }
    return (
      <>
        <TopNavbar />
        <div className="mb-20" />
        <MDBEdgeHeader color="indigo darken-3" className="sectionPage" />
        <div style={{ marginTop: "-200px" }}>
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol lg="3" sm="6" xs="6">
                <MDBAnimation type="zoomIn" duration="500ms">
                  <MDBCard narrow>
                    <MDBCardBody cascade className="text-center">
                      <h6 className="h6-responsive">
                        TOTAL REALISASI TAHUN 2021
                      </h6>
                      <MDBTypography tag="h5" variant="h6-responsive">
                        {random1}%
                      </MDBTypography>
                      <MDBProgress
                        material
                        value={random1}
                        striped
                        color={colorProgress1}
                      />
                      <MDBTypography tag="h5" variant="h5-responsive">
                        {this.state.data
                          ? formatRupiah(this.state.data.realisasi)
                          : "loading..."}
                      </MDBTypography>
                    </MDBCardBody>
                  </MDBCard>
                </MDBAnimation>
              </MDBCol>

              <MDBCol lg="3" sm="6" xs="6">
                <MDBAnimation type="zoomIn" duration="800ms">
                  <MDBCard narrow>
                    <MDBCardBody cascade className="text-center">
                      <h6 className="h6-responsive">
                        TOTAL REALISASI BULAN INI
                      </h6>
                      <MDBTypography tag="h5" variant="h6-responsive">
                        {random2}%
                      </MDBTypography>
                      <MDBProgress
                        material
                        value={random2}
                        striped
                        color={colorProgress2}
                      />
                      <MDBTypography tag="h5" variant="h5-responsive">
                        {this.state.data
                          ? formatRupiah(this.state.data.realisasi_bulan_ini)
                          : "loading..."}
                      </MDBTypography>
                    </MDBCardBody>
                  </MDBCard>
                </MDBAnimation>
              </MDBCol>
              <MDBCol lg="3" sm="6" xs="6">
                <MDBAnimation type="zoomIn" duration="800ms">
                  <MDBCard narrow>
                    <MDBCardBody cascade className="text-center">
                      <h6 className="h6-responsive">
                        TOTAL REALISASI BULAN LALU
                      </h6>
                      <MDBTypography tag="h5" variant="h6-responsive">
                        {random3}%
                      </MDBTypography>
                      <MDBProgress
                        material
                        value={random3}
                        striped
                        color={colorProgress3}
                      />
                      <MDBTypography tag="h5" variant="h5-responsive">
                        {this.state.data
                          ? formatRupiah(this.state.data.realisasi_bulan_lalu)
                          : "loading..."}
                      </MDBTypography>
                    </MDBCardBody>
                  </MDBCard>
                </MDBAnimation>
              </MDBCol>
              <MDBCol lg="3" sm="6" xs="6">
                <MDBAnimation type="zoomIn" duration="800ms">
                  <MDBCard narrow>
                    <MDBCardBody cascade className="text-center">
                      <h6 className="h6-responsive">TOTAL TARGET TAHUN 2021</h6>
                      <MDBTypography tag="h5" variant="h6-responsive">
                        {random4}%
                      </MDBTypography>
                      <MDBProgress
                        material
                        value={random4}
                        striped
                        color={colorProgress4}
                      />
                      <MDBTypography tag="h5" variant="h5-responsive">
                        {this.state.data
                          ? formatRupiah(this.state.data.target)
                          : "loading..."}
                      </MDBTypography>
                    </MDBCardBody>
                  </MDBCard>
                </MDBAnimation>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol lg="6">
                <h3 className="mt-12 text-center lg:text-xl xs:text-xs text-blue-800 font-bold">
                  Realisasi dan Target Berdasarkan Bulan
                </h3>
                <Bar
                  data={dataBarChart.dataBar}
                  options={dataBarChart.lineOption}
                />
              </MDBCol>
              <MDBCol lg="6">
                <h3 className="mt-12 text-center lg:text-xl xs:text-xs text-blue-800 font-bold">
                  Realisasi dan Target Berdasarkan Tahun
                </h3>
                <Line
                  data={dataBarChart.dataLine}
                  options={dataBarChart.lineOption}
                />
              </MDBCol>
            </MDBRow>
          </MDBContainer>
          <MDBContainer fluid>
            <h4 className="mt-12 text-center lg:text-xl xs:text-xs text-blue-800 font-bold">
              Target & Realisasi Berdasarkan OPD
            </h4>
            <MDBTable responsive bordered>
              <MDBTableHead className="view view-cascade gradient-card-header blue-gradient d-flex justify-content-between align-items-center py-2 mx-4 mb-3">
                <tr className="text-center">
                  <th className="w-10 font-bold">#</th>
                  <th className="w-50 font-bold">OPD</th>
                  <th className="w-20 font-bold">TARGET</th>
                  <th className="w-20 font-bold">REALISASI</th>
                  <th className="w-10 font-bold">%</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>{tableSkpd}</MDBTableBody>
            </MDBTable>
          </MDBContainer>
        </div>
      </>
    );
  }
}

export default HomePage;
